import { useEffect } from 'react'
import useActions from './hooks/useActions'
import { loginActions } from './redux/ducks/login'
import { isAuthenticated } from './services/auth'

const GlobalActions = () => {
  const { setIsLogged } = useActions(loginActions)

  // Verify if the user is logged in and update the login state
  useEffect(() => {
    setIsLogged(isAuthenticated())
  }, [setIsLogged])

  return null
}

export default GlobalActions
